import debugFactory from 'debug';
import { useEffect } from 'react';

import { bootstrapConfig, globalConfig } from '~src/context/config';
import { useGlobalState } from '~src/global-state';

const debug = debugFactory('ingrid:checkout-branding');

export const useBrandingStyles = () => {
  const { site_id } = useGlobalState();

  const brandingUrlPath = `${globalConfig.cdnUrl}/checkout-widget-branding/${site_id}/${bootstrapConfig.customStylesheetPath}`;

  useEffect(() => {
    if (!bootstrapConfig.customStylesheetPath) {
      return;
    }
    const link = document.createElement('link');
    try {
      link.rel = 'stylesheet';
      link.href = brandingUrlPath;
      link.type = 'text/css';
      link.onload = () => {
        debug('Branding styles loaded successfully');
      };
      document.head.appendChild(link);
    } catch {
      debug('Branding styles failed to load');
    }

    return () => {
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);
};
